import rOne from "../images/recommended/headphones.jpg";
import rTwo from "../images/recommended/shoe.jpg";
import rThree from "../images/recommended/furniture.jpg";
import rFour from "../images/recommended/refridgerator.jpg";
import rFive from "../images/recommended/watches.jpg";

export const recommended = [
  {
    id: 1,
    name: "Headphones",
    price: 700,
    image: rOne,
  },
  {
    id: 2,
    name: "Shoe",
    price: 500,
    image: rTwo,
  },
  {
    id: 3,
    name: "Furniture",
    price: 1200,
    image: rThree,
  },
  {
    id: 4,
    name: "Refridgerator",
    price: 19000,
    image: rFour,
  },
  {
    id: 5,
    name: "Watches",
    price: 900,
    image: rFive,
  },
  {
    id: 6,
    name: "Headphones",
    price: 700,
    image: rOne,
  },
  {
    id: 7,
    name: "Shoe",
    price: 500,
    image: rTwo,
  },
  {
    id: 8,
    name: "Furniture",
    price: 1200,
    image: rThree,
  },
  {
    id: 9,
    name: "Refridgerator",
    price: 19000,
    image: rFour,
  },
  {
    id: 10,
    name: "Watches",
    price: 900,
    image: rFive,
  },
];
